import React, { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import {
  HighnoteWebhookEventItem,
  isRetryable,
} from 'api/highnote/notificationTasks'
import { useNotificationTasksContextValue } from '../../../context/NotificationTasksProvider'
import { Checkbox } from '@workwhile/ui'
import { IDColumn, selectableColumns } from './columns'

export const useSelectedColumns = (): ColumnDef<HighnoteWebhookEventItem>[] => {
  const {
    state: { selectedColumnsFilters, selectedIds, retryableIds },
    actions: { toggleRow, toggleSelectAll },
  } = useNotificationTasksContextValue()

  const allRetryableSelected =
    retryableIds.length > 0 && retryableIds.every((id) => selectedIds.has(id))

  return useMemo(() => {
    const selectColumn: ColumnDef<HighnoteWebhookEventItem> = {
      id: 'select',
      header: () => (
        <Checkbox
          value={allRetryableSelected}
          onChange={toggleSelectAll}
          disabled={retryableIds.length === 0}
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          value={selectedIds.has(row.original.id)}
          onChange={() => toggleRow(row.original.id)}
          disabled={!isRetryable(row.original)}
        />
      ),
      enableSorting: false,
    }

    const filteredColumns = selectableColumns
      .filter((column) => selectedColumnsFilters.includes(column.id))
      .map((column) => column.columnDef)

    return [selectColumn, IDColumn, ...filteredColumns]
  }, [
    allRetryableSelected,
    retryableIds.length,
    selectedColumnsFilters,
    selectedIds,
    toggleRow,
    toggleSelectAll,
  ])
}
